export default __webpack_public_path__ + "static/media/MyHouse_01.85030525.png";